import React from 'react'
import { useDispatch } from 'react-redux'
import { changeLocation } from 'store/app/actions'

import { ReactComponent as AALogo } from 'assets/images/icons/aa-logo.svg'
import { Wrapper } from './styles'

const SessionHeader = () => {
  const dispatch = useDispatch()

  const handleLogoClick = () => {
    dispatch(changeLocation('/'))
  }

  return (
    <Wrapper>
      <AALogo onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
    </Wrapper>
  )
}

export default SessionHeader
